import FileServiceModel   from '@/models/FileServiceModel';
import doc                from '@widesk-core/decorators/doc';
import model              from '@widesk-core/decorators/model';

@model.urnResource('mime_type')
@doc.path('/stonecode_file_mime_types/{?id}')
export default class MimeTypeModel extends FileServiceModel {
	public declare _tsFilters: {
		'reference': FileMimeTypeReference;
	};

	public declare _tsSorts: {
		'id': string;
		'reference': string;
		'updatedAt': string;
	};

	@doc.string declare reference: FileMimeTypeReference;
}
